import { createListButtonStyles } from "@insite/content-library/Widgets/MyLists/MyListsCreateListButton";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

createListButtonStyles.wrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;

        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    button {
                        background: none !important;
                    }
                `,
                css`
                    button {
                        background: none !important;
                    }
                `,
                null,
                null,
                null,
            ])}
    `,
};
createListButtonStyles.createListButton = {
    variant:"secondary",
};
createListButtonStyles.createListModal = {
    sizeVariant: "small",
};
